module.exports = __webpack_public_path__ + "assets/img/itemHeaderBk1.b2731346.png";